<template>
  <div class="alert-wrapper">
    <v-alert
      v-if="showWarning"
      density="compact"
      class="alert"
      closable>
      <div class="d-flex justify-space-between align-center">
        <span class="d-flex ga-1">
          <v-icon size="small">$warning</v-icon>
          Your trial subscription ends in
          <span v-if="remainingTime.days">{{ remainingTime.days }}d </span>
          <span v-if="remainingTime.hours">{{ remainingTime.hours }}h </span>
          <span v-if="remainingTime.minutes">{{ remainingTime.minutes }}m </span>
          <span v-if="remainingTime.seconds">{{ remainingTime.seconds }}s </span>
        </span>
        <span class="d-inline-flex ga-1"
              v-if="isSubscriptionAdmin && !!activeSubscription?.subscriptionDetails?.cancelAt && !activeSubscription?.scheduleSubscriptionDetails">
          <RouterLink to="/subscription/my-plan" class="upgrade-button">
            upgrade now
          </RouterLink> to avoid interruption!
        </span>
      </div>
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      showWarning: false,
      remainingTime: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      timer: null
    }
  },
  computed: {
    ...mapState({
      userId: state => state.userId,
      currentUser: state => state.user.user,
      activeSubscription: (state) => state.payments.activeSubscription,
      isSubscriptionAdmin: state => state.payments.isSubscriptionAdmin
    }),
    nextBillingDate () {
      const nextBillingDate = this.activeSubscription?.subscriptionDetails?.nextBillingDate
      if (nextBillingDate) {
        return new Date(nextBillingDate)
      }
      return null
    }
  },
  watch: {
    activeSubscription (activeSubscription) {
      if (!!activeSubscription?.subscriptionDetails && activeSubscription.subscriptionDetails.status === 'trialing' && this.nextBillingDate) {
        this.showWarning = true
        this.updateRemainingTime()
        this.startTimer()
      } else {
        this.showWarning = false
        this.stopTimer()
      }
    }
  },
  methods: {
    updateRemainingTime () {
      if (this.nextBillingDate) {
        const now = new Date()
        const diff = this.nextBillingDate - now

        if (diff <= 0) {
          this.stopTimer()
          this.showWarning = false
          return
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24))
        const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((diff % (1000 * 60)) / 1000)

        this.remainingTime = { days, hours, minutes, seconds }
      } else {
        this.remainingTime = { days: 0, hours: 0, minutes: 0, seconds: 0 }
      }
    },
    startTimer () {
      this.stopTimer()
      this.timer = setInterval(this.updateRemainingTime, 1000)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  destroyed () {
    this.stopTimer()
  }
}
</script>

<style scoped>
.alert-wrapper {
  width: 100vw;
  margin-left: -40px;
}

.alert {
  font-size: 14px;
  border-radius: 0;
  background-color: #73E5A6;
}

.upgrade-button {
  color: var(--white, #ffffff);
}

.v-alert__icon {
  font-size: 16px;
}
</style>
